import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Eye, MousePointerClick, Inbox, TrendingUp, Smartphone, Monitor } from "lucide-react";

const Card = ({ icon: Icon, label, value, sub, color = "maroon" }) => (
  <div className="bg-white p-6 rounded-2xl border border-zinc-200">
    <div className="flex items-center justify-between">
      <div className={`w-10 h-10 rounded-lg bg-${color}-50 text-${color}-800 flex items-center justify-center`}><Icon size={18} /></div>
      {sub && <span className="text-xs text-zinc-500">{sub}</span>}
    </div>
    <div className="mt-4 text-3xl font-display font-black text-zinc-900">{value}</div>
    <div className="text-sm text-zinc-500 mt-1">{label}</div>
  </div>
);

const Dashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/analytics/summary").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-zinc-500">Loading...</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-display font-bold text-zinc-900">Dashboard</h1>
          <p className="mt-1 text-sm text-zinc-500">Ringkasan performa & aktivitas website Anda.</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card icon={Eye} label="Total Pageview" value={data.pageviews.total} />
        <Card icon={Users} label="Pengunjung Hari Ini" value={data.pageviews.today} color="amber" />
        <Card icon={TrendingUp} label="Pageview 7 Hari" value={data.pageviews.week} />
        <Card icon={TrendingUp} label="Pageview 30 Hari" value={data.pageviews.month} />
        <Card icon={MousePointerClick} label="Total Klik" value={data.clicks.total} color="maroon" />
        <Card icon={MousePointerClick} label="Klik WhatsApp" value={data.clicks.whatsapp} color="amber" />
        <Card icon={Inbox} label="Total Leads" value={data.leads.total} />
        <Card icon={Inbox} label="Leads Baru" value={data.leads.new} color="amber" sub="Belum ditangani" />
      </div>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-2xl border border-zinc-200">
          <h3 className="font-display font-bold text-zinc-900 mb-4">Halaman Terpopuler</h3>
          <div className="space-y-3">
            {data.top_pages.length === 0 && <div className="text-sm text-zinc-500">Belum ada data.</div>}
            {data.top_pages.map((p, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-zinc-100 last:border-0">
                <span className="text-sm text-zinc-700 truncate">{p.page || "-"}</span>
                <span className="text-sm font-bold text-maroon-800">{p.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-zinc-200">
          <h3 className="font-display font-bold text-zinc-900 mb-4">Klik Populer</h3>
          <div className="space-y-3">
            {data.top_clicks.length === 0 && <div className="text-sm text-zinc-500">Belum ada data.</div>}
            {data.top_clicks.map((c, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-zinc-100 last:border-0">
                <span className="text-sm text-zinc-700">{c.label || "-"}</span>
                <span className="text-sm font-bold text-maroon-800">{c.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-zinc-200 lg:col-span-2">
          <h3 className="font-display font-bold text-zinc-900 mb-4">Device Distribution</h3>
          <div className="flex flex-wrap gap-4">
            {data.devices.map((d, i) => (
              <div key={i} className="flex items-center gap-3 px-5 py-3 rounded-xl bg-zinc-50">
                {d.device === "mobile" ? <Smartphone size={16} className="text-maroon-800" /> : <Monitor size={16} className="text-maroon-800" />}
                <span className="text-sm text-zinc-700 capitalize">{d.device}</span>
                <span className="text-sm font-bold text-zinc-900">{d.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
